import { onPageLoad, onPageTeardown } from '../modules/page_lifecycle.js';
import { bindAjaxPagination, pageFromHref } from '../modules/ajax_pagination.js';
import { bindTemplatePopovers } from '../modules/bootstrap_ui.js';
import { qs, qsa } from '../modules/dom.js';

function bindAssociatedProjectToggles() {
  qsa('table.tbl_assoc_proj tbody.tbody_assoc_proj').forEach((body) => {
    body.style.display = 'none';
  });

  qsa('a.link_assoc_proj').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const id = link.id;
      const body = qs(`#ap_tbody_${id}`);
      if (body) {
        body.style.display = body.style.display === 'none' ? '' : 'none';
      }

      if (link.textContent.trim() === '[-]') {
        link.textContent = ' [+]';
      } else {
        link.textContent = ' [-]';
      }
    });
  });
}


function loadPaginatedSection(containerSelector, url) {
  bindAjaxPagination(containerSelector, (href, container) => {
    const page = pageFromHref(href);
    const params = new URLSearchParams({
      id: window.ProjectSettings?.id,
      page
    });
    return `${url}?${params.toString()}`;
  });
}

bindTemplatePopovers(
  ['#progress-rating-popover', '#associated-progress-rating-popover'],
  { title: 'What does progress rating mean?', templateId: 'progress-rating-panel' }
);

bindTemplatePopovers(
  ['#reality-rating-popover', '#associated-reality-rating-popover'],
  { title: 'What does reality rating mean?', templateId: 'reality-rating-panel' }
);

onPageLoad(() => {
  if (!qs('#project')) return;

  bindAssociatedProjectToggles();
  loadPaginatedSection('#newsList', '/projects/news');
  loadPaginatedSection('#projectTrackerList', '/projects/tracker_updates');
});

onPageTeardown(() => {
  if (typeof GUnload !== 'undefined') GUnload();
});

window.addEventListener('unload', () => {
  if (typeof GUnload !== 'undefined') GUnload();
});
